export const TOKEN = {
    BUFFER: 30000, // seconds
};
//# sourceMappingURL=token.js.map